import React from 'react';
import { Image } from "primereact/image";

const ImageComponent = ({src, alt}) => {
    return (
        <Image src={src} zoomSrc={src} alt={alt} preview width='100%' />
    );
};

export default ImageComponent;